module.exports = __webpack_public_path__ + "img/spIcon.a7253716.png";